import {TSMap} from 'typescript-map';

export class FacebookTwitterJson {

  questionNo:number;

  useImageAsUrl:boolean;

  socialMessage:TSMap<string,string>; // represents a message for twitter and a ogTitle for facebook

  title:TSMap<string,string>;

  description:TSMap<string,string>;

  // currentValues
  currentTitle:string;
  currentDesc:string;
  currentMsg:string;


  constructor(json:any) {

    this.socialMessage = new TSMap();
    this.description = new TSMap();
    this.title = new TSMap();

    this.questionNo = json.questionNo;

    this.useImageAsUrl = json.useImageAsUrl;


    if(json.socialMessage != null) {
      for(const key of Object.keys(json.socialMessage)) {
          this.socialMessage.set(key,json.socialMessage[key]);
      }
    }

    if(json.title != null) {
      for(const key of Object.keys(json.title)) {
        this.title.set(key,json.title[key]);
      }
    }


    if(json.title != null) {
      for(const key of Object.keys(json.description)) {
        this.description.set(key,json.description[key]);
      }
    }



  }

  public getTitle(lang:string):string {
    return this.title.get(lang);
  }

  public getDesc(lang:string):string {
    return this.description.get(lang);
  }

  public getMessage(lang:string):string {
    return this.socialMessage.get(lang);
  }

  public getLanguages():string[] {
    return this.socialMessage.keys();
  }


}
